module.exports = __webpack_public_path__ + "img/cosleep_guidance_img_subscribe-wechat7_cn@3x.9b5286b6.png";